import React, { FC } from "react";
import { Card, Stack, Typography } from "@mui/material";
import { AnButton } from "../assets/Components/Login/AnButton";

export const SsoUnknownUser: FC<{
  email: string;
  provider: string;
  primaryColor: string;
}> = ({ email, provider, primaryColor }) => {
  return (
    <Card
      sx={{
        p: 4,
        maxWidth: 343,
        mb: 3,
        ml: "auto",
        mr: "auto",
      }}
      elevation={3}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          fontSize: "20px",
          lineHeight: "24px",
        }}
      >
        We don’t recognize this email
      </Typography>

      <Typography
        variant="body2"
        sx={{
          mt: 3,
        }}
      >
        We couldn&rsquo;t find a Floify account matching this login ({email}).
        Please contact your loan officer.
      </Typography>

      <Stack>
        <AnButton
          sx={{
            mt: 3,
            color: "#fff !important",
          }}
          applyNowColor={primaryColor}
          size="large"
          variant="contained"
          disableRipple={true}
          href="/login"
        >
          Log in with different email
        </AnButton>
        {/* FLO-15514 follow-up: SAML has no registration-provisioning flow wired through the ACS
            yet, so there's no working "create a new account" URL to offer for it. */}
        {provider !== "saml" && (
          <AnButton
            sx={{
              mt: 1.5,
              borderColor: "#000",
            }}
            size="large"
            variant="outlined"
            disableRipple={true}
            href={`/oidc/register/${provider}`}
          >
            Create a new account
          </AnButton>
        )}
      </Stack>
    </Card>
  );
};
